import { render, staticRenderFns } from "./alarm-level.vue?vue&type=template&id=15c95b1b&scoped=true&"
import script from "./alarm-level.vue?vue&type=script&lang=ts&"
export * from "./alarm-level.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-level.vue?vue&type=style&index=0&id=15c95b1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c95b1b",
  null
  
)

export default component.exports